'use strict';

var React = require('react');

var SvgWholesaleMajor = function SvgWholesaleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 3a1 1 0 1 0-2 0v5.392a2.5 2.5 0 0 0-.32-1.223l-2.184-3.892a2.5 2.5 0 0 0-2.18-1.277h-2.816a2.5 2.5 0 0 0-2.5 2.5v1.5h-2.5a1.5 1.5 0 0 0-1.5 1.5v2.585a1.5 1.5 0 0 0-1 1.415v5.5a3 3 0 1 0 6 0h3a3 3 0 1 0 6 0v-2h4a1 1 0 1 0 0-2h-2v-10zm-14 7h2v-2h-2v2zm10-1.608v1.608h-6v-5.5a.5.5 0 0 1 .5-.5h2.816a.5.5 0 0 1 .436.255l2.184 3.892a.5.5 0 0 1 .064.245zm-9 8.608a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }));
};

exports.SvgWholesaleMajor = SvgWholesaleMajor;
